<template>
  <div id="app" style="height: 100vh;">
    <router-view></router-view>
  </div>
</template>


<script>
// 网页版已移除注册 / 登录与支付订阅：全站免登录、免费使用。
// 后端账号与计费接口保留不动，仅供微信小程序调用。
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

body {
    display: block;
    margin: 0px;
}
</style>
